import { FormState, FormValidator } from "./types";

export const getValidationErrors = (
  validators: FormValidator[] | undefined,
  ...values: [any, FormState]
): string[] => {
  return (validators ?? [])
    .filter((validator) => !validator.isValid(...values))
    .map((validator) => validator.error);
};
